import React, { useState, useEffect } from "react";
import IframeRoutes from "./routes/IframeRoutes";
import { useLocation, useHistory } from "react-router-dom";
import ErrorHandler from "components/common/ErrorHandler";
import { errorState } from "recoil/error/atom";
import { modalState } from "recoil/modal/atom";
import { JL } from "jsnlog";
import ModalComponent from "components/common/ModalComponent";
import { toastMessageState } from "recoil/toast/atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { setcompanyDetails } from "recoil/companyDetails/selector";
import { getEmployeeAuthorisation, useGetCompanyDetails } from "swr/auth";
import { setCurrentOrganisationDetails } from "recoil/organisations/selector";
import { ToastHandler } from "qjumpers.common.ui";
import environmentConfig from "constants/config";
import { jwtDecode } from 'jwt-decode';
import { validateToken } from "swr/users";
import { getRulesDetails } from "utils/authHelper";
import { loadNoteTypes } from "swr/notes";
import { loadDocumentCategoriesByOrg } from "swr/documentcategory";
import { setNoteTypes } from "recoil/noteTypes/selector";
import { setDocumentCategories } from "recoil/documentCategories/selector";
import LoadingWidget from "./widgets/loader";
import 'react-toastify/dist/ReactToastify.css';
import Keycloak from "keycloak-js";
import config from "constants/config";
export function createKeycloakWithTokens({ accessToken, refreshToken, idToken }) {
  const keycloak = new Keycloak({
    url: config.KEYCLOAK.apiHost + config.KEYCLOAK.apiPath,
    realm: "qjumpers",
    clientId: "qjumpers",
  });
  keycloak.init({
    onLoad: "check-sso",
    token: accessToken,
    refreshToken: refreshToken,
    idToken: idToken,
  });
  return keycloak;
}

function IframeApp(props) {
  const history = useHistory();
  const location = useLocation();
  const error = useRecoilValue(errorState);
  const modal = useRecoilValue(modalState);
  const toast = useRecoilValue(toastMessageState);
  const setToast = useSetRecoilState(toastMessageState);
  const noteTypesData = useSetRecoilState(setNoteTypes);
  const documentCategoriesData = useSetRecoilState(setDocumentCategories);
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [organisation, setOrganisationData] = useState(null);
  const [currentCompanyDetails, setCurrentCompanyDetails] = useState();
  const [employeeAuthorization, setEmployeeAuthorizationState] = useState(null);
  const [rulesDetails, setRulesDetails] = useState();
  const [userId, setUserId] = useState();
  const keycloakRef = React.useRef(null);
  const setCurrentOrgValue = useSetRecoilState(setCurrentOrganisationDetails);
  const setCompanyDetailsState = useSetRecoilState(setcompanyDetails);

  JL.setOptions({ defaultAjaxUrl: `${environmentConfig.ADMIN.apiHost}/jsnlog.logger` });
  useEffect(() => {
    JL.setOptions({
      defaultAjaxUrl: `${environmentConfig.ADMIN.apiHost}/jsnlog.logger`,
    });

    // Override the console object to ship logs to the backend
    const console = (oldCons => {
      return {
        log: function (...msg) {
          oldCons.log(...msg);
          JL("client").log(...msg);
        },
        info: function (...msg) {
          oldCons.info(...msg);
          JL("client").info(...msg);
        },
        warn: function (...msg) {
          oldCons.warn(...msg);
          JL("client").warn(...msg);
        },
        error: function (...msg) {
          oldCons.error(...msg);
          JL("client").error(...msg);
        },
      };
    })(window.console);
    window.console = console;

    // Configure appenders for jsnlog
    const ajaxAppender = JL.createAjaxAppender("ajaxAppender");
    const consoleAppender = JL.createConsoleAppender("consoleAppender");
    JL("client").setOptions({ appenders: [ajaxAppender, consoleAppender] });

    if (keycloakRef.current) {
      if (keycloakRef.current.isTokenExpired(0)) {
        console.log("token expired, reloading...");
        window.location.reload();
      }
    }
  }, []);

  const validateTokenWithKeycloak = async (token) => {
    try {
      const response = await validateToken(token);

      if (response && response.status === 200 && response.data) {
        const tokens = response.data.tokens;
        const currentCompany = response.data.organisation;
        console.log("Token: after validate response success");
        try {
          if (!keycloakRef.current) {
            keycloakRef.current = createKeycloakWithTokens({
              accessToken: tokens.access_token,
              refreshToken: tokens.refresh_token,
              idToken: tokens.id_token,
            });
            keycloakRef.current.onTokenExpired = () => {
              keycloakRef.current.updateToken(30)
                .then((refreshed) => {
                  if (refreshed) {
                    console.log("Token successfully refreshed");
                    localStorage.setItem("qjumpers.adminui.auth.token", keycloakRef.current.token);
                  } else {
                    console.log("Token is still valid, no refresh needed");
                  }
                })
                .catch(() => {
                  console.error("Failed to refresh token. Logging out...");
                });
            };
          }
          localStorage.setItem("qjumpers.adminui.auth.token", tokens.access_token);
          localStorage.setItem("company-id", currentCompany.id);
          localStorage.setItem("company-name", currentCompany.accountingName);
        } catch (storageError) {
          console.error("Error:", storageError);
        }
        const authResult = await getEmployeeAuthorisation(currentCompany.id);
        if (authResult.data) {
          setEmployeeAuthorizationState(authResult.data);
        }
        setOrganisationData(currentCompany);
        setCurrentOrgValue(currentCompany);
        return currentCompany.organisationSettings.activated;
      }
      else {
        localStorage.removeItem("company-id");
        localStorage.removeItem("company-name");
      }
    } catch (error) {
      localStorage.removeItem("company-id");
      localStorage.removeItem("company-name");
      console.error('Token validation failed:', error);
      return false;
    }
  };

  useEffect(() => {
    console.log("load component");
    const validateToken = async () => {
      let token = null;
      const messageHandler = async (event) => {
        //console.log("iframeOriginSrc", environmentConfig.iframeOriginSrc);
        // const iframeAppSrcPatterns = environmentConfig.iframeOriginSrc
        //   .trim()
        //   .split(";")
        //   .map(src =>
        //     src.trim()
        //       .replace(/\./g, "\\.")
        //       .replace(/\*/g, ".*")
        // );
        // const allowedOrigins = iframeAppSrcPatterns.map(pattern => new RegExp(`^${pattern}$`));
        // console.log("Allowed Origins Regex:", allowedOrigins);
        // Check if the event origin is allowed
        // if (!allowedOrigins.some(pattern => pattern.test(event.origin))) {
        //   console.error("Untrusted origin:", event.origin);
        //   return;
        // }
        const queryParams = new URLSearchParams(location.search);
        token = queryParams.get("jwt");
        const data = event.data;
        if (!token && data && data.access_token) {
          token = data.access_token;
        }
        if (!token) {
          console.log("No token found in the URL or message event.");
          return;
        }

        try {
          const decodedToken = jwtDecode(token);
          const isExpired = decodedToken.exp * 1000 < Date.now();
          if (isExpired) {
            setIsAuthorized(false);
            history.replace('/error');
            return;
          }
          setUserId(decodedToken.sub);
          // Await the token validation asynchronously
          const isValid = await validateTokenWithKeycloak(token);
          setIsAuthorized(isValid);
        } catch (error) {
          console.error('Token decoding failed:', error);
          history.replace('/error');
        }
      };
      window.addEventListener('message', messageHandler);
      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('message', messageHandler);
      };
    };

    validateToken();
  }, [location.search]);

  useEffect(() => {
    if (organisation && userId) {
      useGetCompanyDetails(userId).then((response) => {
        const currentCompany = response?.data.find((company) => company.id === organisation.id);
        setCompanyDetailsState(currentCompany);
        setCurrentCompanyDetails(currentCompany);
      });
    }
  }, [organisation, userId]);

  useEffect(() => {
    if (organisation && employeeAuthorization && !rulesDetails) {
      const rules = getRulesDetails(currentCompanyDetails, organisation, employeeAuthorization);
      setRulesDetails(rules);
    }
  }, [employeeAuthorization, organisation, currentCompanyDetails]);

  useEffect(() => {
    const fetchAdditionalData = async () => {
      try {
        const noteTypesResponse = await loadNoteTypes();
        const categoriesResponse = await loadDocumentCategoriesByOrg(organisation.id);
        noteTypesData(noteTypesResponse.data);
        documentCategoriesData(categoriesResponse.data);
      } catch (error) {
        console.error('Failed to fetch additional data:', error);
      }
    };

    if (isAuthorized) {
      fetchAdditionalData();
    }
  }, [isAuthorized]);

  const clearToastMessage = () => setToast([]);

  return (
    <div className="App">
      {isAuthorized ? (
        <>
          <ErrorHandler errors={error} />
          <ModalComponent modalData={modal} />
          <ToastHandler toast={toast} clearToasts={clearToastMessage} />
          {employeeAuthorization && rulesDetails && (
            <IframeRoutes rulesDetails={rulesDetails} />
          )}
        </>
      ) : isAuthorized === null ? (
        <div style={{ textAlign: "center", padding: "5rem" }}>
          <LoadingWidget color="grey" />
          <div>Authenticating user...</div>
        </div>
      ) : (
        <div>Unauthorized</div>
      )}
    </div>
  );
}

export default IframeApp;